module.exports = __webpack_public_path__ + "static/img/logo.18e81dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo.png
// module id = ZBJ4
// module chunks = 0